var map = {
	"./ibd_arm1.png": 153,
	"./ibd_arm2.png": 154,
	"./ibd_arm3.png": 155,
	"./ibd_back1.png": 156,
	"./ibd_back2.png": 157,
	"./ibd_foot1.png": 158,
	"./ibd_hips1.png": 159,
	"./ibd_hips2.png": 160,
	"./ibd_neck1.png": 161,
	"./ibd_neck2.png": 162,
	"./ibd_neck3.png": 163,
	"./ibd_shoulder1.png": 164,
	"./ibd_shoulder2.png": 165,
	"./ibd_shoulder3.png": 166
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 152;